(function () {
  'use strict';

  if (window.gmMiniCartV3Initialized) return;
  window.gmMiniCartV3Initialized = true;
  window.gmMobileCartHealthInitialized = true;
  window.gmMiniCartSafetyInitialized = true;

  var installAttempts = 0;

  function themeObject() {
    return window.theme || {};
  }

  function isNarrowViewport() {
    var width = Number(window.innerWidth || document.documentElement.clientWidth || 0);
    return Boolean((window.matchMedia && window.matchMedia('(max-width: 600px)').matches) || width <= 600);
  }

  function mobileHolder() {
    return document.getElementById('cart-count-mobile');
  }

  function desktopHolder() {
    return document.getElementById('cart-count-desktop');
  }

  function dropdown() {
    return document.getElementById('cart-dropdown');
  }

  function keepDropdownInCorrectHolder() {
    var cartDropdown = dropdown();
    if (!cartDropdown) return;
    var holder = isNarrowViewport() ? mobileHolder() : desktopHolder();
    if (holder && cartDropdown.parentNode !== holder) holder.appendChild(cartDropdown);
  }

  function normalizeDesktopFooter() {
    if (isNarrowViewport()) return;
    var cartDropdown = dropdown();
    if (!cartDropdown) return;
    var footer = cartDropdown.querySelector('li.buttons');
    if (!footer) return;

    footer.classList.add('gm-mini-cart-actions');
    var actionIndex = 0;
    Array.prototype.slice.call(footer.children).forEach(function (child) {
      if (child.classList.contains('shipping_msg')) {
        child.classList.add('gm-mini-cart-shipping');
        return;
      }
      if (!child.classList.contains('six') && !child.classList.contains('gm-mini-cart-action')) return;
      actionIndex += 1;
      child.classList.remove('six', 'mobile', 'negative-left', 'negative-right');
      child.classList.add('gm-mini-cart-action');
      child.classList.toggle('gm-mini-cart-action--view', actionIndex === 1);
      child.classList.toggle('gm-mini-cart-action--checkout', actionIndex === 2);
    });
  }

  function installDesktopCartStyles() {
    if (document.getElementById('gm-mini-cart-desktop-styles')) return;
    var style = document.createElement('style');
    style.id = 'gm-mini-cart-desktop-styles';
    style.textContent = [
      '@media screen and (min-width:601px){',
      '#cart-count-desktop.cart-info{position:relative!important;}',
      '#cart-count-desktop #cart-dropdown{box-sizing:border-box!important;left:auto!important;right:-1px!important;top:100%!important;width:440px!important;min-width:440px!important;max-width:440px!important;height:auto!important;margin:0!important;padding:0!important;background:#fff!important;border:1px solid #e2e6ec!important;border-radius:10px!important;box-shadow:0 14px 34px rgba(20,28,45,.16)!important;color:#172033!important;overflow:hidden!important;white-space:normal!important;list-style:none!important;}',
      '#cart-count-desktop #cart-dropdown .modal-close{display:none!important;}',
      '#cart-count-desktop #cart-dropdown>span.skip{box-sizing:border-box!important;display:block!important;width:100%!important;max-height:min(58vh,430px)!important;margin:0!important;padding:0!important;background:#fff!important;color:#172033!important;overflow-x:hidden!important;overflow-y:auto!important;overscroll-behavior:contain!important;white-space:normal!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-item{box-sizing:border-box!important;display:block!important;width:100%!important;min-height:0!important;margin:0!important;padding:14px 16px!important;background:#fff!important;border:0!important;border-bottom:1px solid #e8ebf0!important;color:#172033!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-item.last{border-bottom:0!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-row{box-sizing:border-box!important;display:grid!important;grid-template-columns:90px minmax(0,1fr)!important;gap:14px!important;align-items:start!important;width:100%!important;min-height:0!important;margin:0!important;padding:0!important;font-size:initial!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-row--no-image{grid-template-columns:minmax(0,1fr)!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-thumb{box-sizing:border-box!important;display:block!important;width:90px!important;height:90px!important;min-width:90px!important;min-height:90px!important;margin:0!important;padding:0!important;background:#f7f8fa!important;border:1px solid #eef0f3!important;border-radius:7px!important;overflow:hidden!important;position:relative!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-thumb img{box-sizing:border-box!important;display:block!important;position:absolute!important;left:50%!important;top:50%!important;width:100%!important;max-width:100%!important;height:100%!important;max-height:none!important;margin:0!important;padding:0!important;object-fit:contain!important;transform:translate(-50%,-50%)!important;background:#f7f8fa!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-details{box-sizing:border-box!important;display:block!important;min-width:0!important;width:100%!important;margin:0!important;padding:0!important;color:#172033!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-title{margin:0 0 7px!important;padding:0!important;font-size:14px!important;line-height:1.28!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-title a{display:-webkit-box!important;height:auto!important;margin:0!important;padding:0!important;color:#172033!important;font-size:14px!important;font-weight:700!important;line-height:1.28!important;text-decoration:none!important;white-space:normal!important;overflow:hidden!important;overflow-wrap:anywhere!important;word-break:normal!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:3!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-title a:hover,#cart-count-desktop #cart-dropdown .gm-mini-cart-title a:focus{color:#e32e00!important;text-decoration:underline!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-title small{display:block!important;margin-top:2px!important;font-size:11px!important;font-weight:600!important;line-height:1.2!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-subtext,#cart-count-desktop #cart-dropdown .gm-mini-cart-properties{margin:0 0 6px!important;padding:0!important;color:#667085!important;font-size:11px!important;line-height:1.35!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-properties span{display:block!important;margin:0!important;padding:0!important;color:#667085!important;font-size:11px!important;line-height:1.35!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-meta{display:flex!important;align-items:center!important;gap:7px 12px!important;flex-wrap:wrap!important;margin:0!important;padding:0!important;color:#5f6878!important;font-size:12px!important;line-height:1.35!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-meta span{display:inline!important;margin:0!important;padding:0!important;color:#5f6878!important;font-size:12px!important;line-height:1.35!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-discounts{display:block!important;margin:6px 0 0!important;padding:0!important;color:#157347!important;font-size:11px!important;line-height:1.35!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-discounts span{display:block!important;margin:0!important;padding:0!important;color:#157347!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-total{box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;width:100%!important;margin:8px 0 0!important;padding:8px 0 0!important;border-top:1px solid #edf0f3!important;color:#172033!important;font-size:12px!important;line-height:1.3!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-total span,#cart-count-desktop #cart-dropdown .gm-mini-cart-total strong{display:inline!important;margin:0!important;padding:0!important;color:#172033!important;font-size:12px!important;line-height:1.3!important;}',
      '#cart-count-desktop #cart-dropdown li.buttons.gm-mini-cart-actions{box-sizing:border-box!important;display:grid!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;gap:10px!important;width:100%!important;min-height:0!important;margin:0!important;padding:14px 16px 16px!important;background:#fff!important;border:0!important;border-top:1px solid #e8ebf0!important;position:relative!important;bottom:auto!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-shipping{box-sizing:border-box!important;grid-column:1/-1!important;width:100%!important;margin:0 0 4px!important;padding:0!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action{box-sizing:border-box!important;display:block!important;float:none!important;width:100%!important;max-width:none!important;height:auto!important;margin:0!important;padding:0!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action--view{grid-column:1!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action--checkout{grid-column:2!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action form{display:block!important;width:100%!important;height:auto!important;margin:0!important;padding:0!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action a.btn,#cart-count-desktop #cart-dropdown .gm-mini-cart-action button.btn{box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;max-width:none!important;min-width:0!important;min-height:44px!important;height:44px!important;margin:0!important;padding:8px 10px!important;border:2px solid #e32e00!important;border-radius:6px!important;font-size:13px!important;font-weight:700!important;line-height:1.2!important;text-align:center!important;text-decoration:none!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action a.btn.outline{background:#fff!important;color:#2d3442!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action button.btn,#cart-count-desktop #cart-dropdown .gm-mini-cart-action a.btn:not(.outline){background:#e32e00!important;border-color:#e32e00!important;color:#fff!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action a.btn.outline:hover,#cart-count-desktop #cart-dropdown .gm-mini-cart-action a.btn.outline:focus{background:#fff5f2!important;border-color:#bd2600!important;color:#bd2600!important;}',
      '#cart-count-desktop #cart-dropdown .gm-mini-cart-action button.btn:hover,#cart-count-desktop #cart-dropdown .gm-mini-cart-action button.btn:focus{background:#bd2600!important;border-color:#bd2600!important;color:#fff!important;}',
      '}',
      '@media screen and (min-width:601px) and (max-width:760px){#cart-count-desktop #cart-dropdown{right:0!important;width:min(440px,calc(100vw - 24px))!important;min-width:0!important;max-width:calc(100vw - 24px)!important;}}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(style);
  }

  function setDesktopHover(open) {
    var desktop = desktopHolder();
    var mobile = mobileHolder();
    if (mobile) mobile.classList.remove('hover', 'avoid');
    if (!desktop) return;
    desktop.classList.toggle('hover', Boolean(open));
    var trigger = desktop.querySelector('.keydown-link');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeMobileState() {
    var mobile = mobileHolder();
    document.body.classList.remove('cart-open');
    if (mobile) mobile.classList.remove('hover', 'avoid');
  }

  function replaceMobileButtonWithCartLink() {
    var holder = mobileHolder();
    if (!holder) return;
    var trigger = holder.querySelector('.cart-count-mobile');
    if (!trigger) return;
    var route = themeObject().routes_cart_url || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart');
    if (trigger.tagName === 'A') {
      trigger.href = route;
      trigger.classList.remove('void');
      return;
    }
    var link = document.createElement('a');
    link.href = route;
    link.className = trigger.className.replace(/\bvoid\b/g, '').replace(/\s{2,}/g, ' ').trim();
    link.innerHTML = trigger.innerHTML;
    link.setAttribute('role', 'button');
    var label = trigger.getAttribute('aria-label');
    if (label) {
      link.setAttribute('aria-label', label);
      link.title = label;
    }
    trigger.replaceWith(link);
  }

  function updateCartChrome(itemCount, total) {
    var normalized = Math.max(0, Number(itemCount) || 0);
    document.querySelectorAll('.cartCountSelector').forEach(function (node) {
      node.textContent = String(normalized);
      node.classList.toggle('hidden', normalized < 1);
    });
    var totalNode = document.querySelector('.cartTotalSelector');
    if (totalNode && typeof total === 'string') totalNode.innerHTML = total;
  }

  function refreshMiniCart(skipOpen) {
    var currentTheme = themeObject();
    if (typeof window.ShippingMsg === 'function') {
      try { window.ShippingMsg(); } catch (error) {}
    }
    var cartUrl = currentTheme.routes_cart_url || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart');
    return fetch(cartUrl + '?section_id=cart-dropdown', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart dropdown.');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('#cart-dropdown');
        var cartDropdown = dropdown();
        if (!source || !cartDropdown) return;

        keepDropdownInCorrectHolder();
        var itemCount = Number(source.getAttribute('data-items') || 0);
        var total = source.getAttribute('data-total') || '';
        updateCartChrome(itemCount, total);

        var itemHolder = cartDropdown.querySelector('span.skip') || cartDropdown.querySelector('span');
        if (itemHolder) itemHolder.innerHTML = source.innerHTML;

        if (itemCount > 0) {
          cartDropdown.classList.remove('hidden');
          if (isNarrowViewport()) {
            closeMobileState();
            replaceMobileButtonWithCartLink();
          } else {
            installDesktopCartStyles();
            normalizeDesktopFooter();
            setDesktopHover(!skipOpen && currentTheme.dropdown === true);
          }
        } else {
          cartDropdown.classList.add('hidden');
          setDesktopHover(false);
          closeMobileState();
          replaceMobileButtonWithCartLink();
        }
      })
      .catch(function (error) {
        console.error('Gummy Molds mini cart:', error);
      });
  }

  function installCartDropOverride() {
    if (window.CartDrop && window.CartDrop.__gmMiniCartV3) return;
    if (typeof window.CartDrop !== 'function') {
      installAttempts += 1;
      if (installAttempts < 60) window.setTimeout(installCartDropOverride, 50);
      return;
    }
    var replacement = function (skipOpen) {
      return refreshMiniCart(Boolean(skipOpen));
    };
    replacement.__gmMiniCartV3 = true;
    window.CartDrop = replacement;
  }

  function stabilizeCart() {
    installCartDropOverride();
    keepDropdownInCorrectHolder();
    if (isNarrowViewport()) {
      closeMobileState();
      replaceMobileButtonWithCartLink();
    } else {
      document.body.classList.remove('cart-open');
      installDesktopCartStyles();
      normalizeDesktopFooter();
      var closeButton = dropdown() && dropdown().querySelector('.modal-close');
      if (closeButton) closeButton.classList.add('hidden');
    }
  }

  function scheduleStabilize() {
    window.setTimeout(stabilizeCart, 0);
    window.setTimeout(stabilizeCart, 200);
  }

  document.addEventListener('cartItems', scheduleStabilize);
  document.addEventListener('shopify:section:load', scheduleStabilize);
  window.addEventListener('resize', scheduleStabilize);
  window.addEventListener('orientationchange', scheduleStabilize);
  window.addEventListener('pageshow', scheduleStabilize);

  installDesktopCartStyles();
  installCartDropOverride();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      stabilizeCart();
      window.setTimeout(stabilizeCart, 250);
    }, { once: true });
  } else {
    stabilizeCart();
    window.setTimeout(stabilizeCart, 250);
  }
})();